// extracted by mini-css-extract-plugin
export default {"container":"StepFooter_container__l80lQ","btnBack":"StepFooter_btnBack__19d4q","btn":"StepFooter_btn__aUS0v"};